import { useQuery } from "react-query";
import axios from "axios";
import { GetTokenFunc } from "../../utils/GetToken";

const normalizeMembershipTier = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "");

export function findMembershipPlanByTier(plans, tier) {
  const wanted = normalizeMembershipTier(tier);
  if (!wanted || !Array.isArray(plans)) return null;

  const byNameOrType = plans.find((plan) => {
    const name = normalizeMembershipTier(plan?.PlanName);
    const type = normalizeMembershipTier(plan?.PlanType);
    return name === wanted || type === wanted;
  });
  if (byNameOrType) return byNameOrType;

  const legacyAliases = {
    starter: ["basic", "start"],
    growth: ["standard", "medium"],
    enterprise: ["premium", "pro"],
  };
  const aliases = legacyAliases[wanted] || [];
  return (
    plans.find((plan) => {
      const name = normalizeMembershipTier(plan?.PlanName);
      const type = normalizeMembershipTier(plan?.PlanType);
      return aliases.some((alias) => name === alias || type === alias);
    }) || null
  );
}

export function mapMembershipPlanToFormFields(plan, tierPrefix) {
  return {
    [`${tierPrefix}PlanId`]: plan?._id,
    [`${tierPrefix}PlanType`]: plan?.PlanType,
    [`${tierPrefix}PlanName`]: plan?.PlanName,
    [`${tierPrefix}PlanPrice`]: plan?.PlanPrice,
    [`${tierPrefix}PlanGST`]: plan?.GST,
    [`${tierPrefix}PlanisActive`]: plan?.isActive,
    [`${tierPrefix}PlanCommissionPercentage`]: plan?.commissionPercentage,
    [`${tierPrefix}PlanRenewalFee`]: plan?.renewalFee,
    [`${tierPrefix}PlanValidityMonths`]: plan?.validityMonths,
    [`${tierPrefix}PlanCreditValidityMonths`]: plan?.creditValidityMonths,
  };
}

export const useFetchMemberShipPlan = () => {
  return useQuery(["membershipplan"], async () => {
    try {
      const response = await axios.get(`membership/getallmembership`, {
        headers: {
          authorization: `bearer ${GetTokenFunc()}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  });
};
